export const styleWheel = {
    position: 'absolute',
    width: '30px',
    height: '30px',
    top: '6px',
    right: '15px',
    cursor: 'pointer'
};